import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  @Output() scrolledToBottom = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }
  onScroll(event: any): void {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      // User has scrolled to the bottom
      this.scrolledToBottom.emit(true);
    }
  }
}
